module.exports = __webpack_public_path__ + "static/digilege_logo-80dd9d85fd1e93d2e813c47d3311882b.png";